import store from './store/store'; // Ensure this is a Vuex 4+ store instance (created with createStore)
import { createApp, ComponentPublicInstance } from 'vue'; // Import createApp and ComponentPublicInstance
import OnBoarding from './OnBoarding.vue';
import { OnBoardingGoal } from '../utils/models/OnBoardingGoal'; // Ensure path is correct
import { AuthMethods } from './store/modules/OnBoardingModule'; // Ensure path is correct

// Define the type for the exposed component instance (optional, but good practice)
// You might want to refine this type based on what you actually need to access globally
// interface OnBoardingComponentInstance extends ComponentPublicInstance {
//   // Add any specific methods/properties from OnBoarding if needed globally
// }

type AddToListContext = {
  hikeId?: string | number;
  trailId?: number;
  slug?: string;
  regionSlug?: string;
  countrySlug?: string;
};

interface OnBoardingGlobal extends ComponentPublicInstance {
  launchFor: (goal: OnBoardingGoal, authMethods?: AuthMethods[]) => Promise<void>;
  setAddToListContext?: (context: AddToListContext) => void;
}

declare global {
  interface Window {
    // Update the type of the Vue instance exposed on the window
    onBoardingVue?: OnBoardingGlobal;

    // Define the new global function type
    launchOnBoardingFor?: (goal: OnBoardingGoal, authMethods?: AuthMethods[]) => Promise<void>;

    // Keep other existing global properties
    slug: string;
    region_slug: string;
    country_slug: string;
    id: number;
    stripeApiKey: string;
  }
}

const onBoardingEl = document.getElementById('on_boarding');

if (onBoardingEl) {
  // Function to initialize and mount the app
  const initializeAndMountOnboarding = async () => {
    try {
      // --- Equivalent of beforeCreate logic ---
      // Initialize the store *before* creating the app instance
      // Use the imported 'store' directly
      await store.dispatch('onBoarding/initialiseStore');
      await store.dispatch('onBoarding/updateUserForFb');
      // --- End of beforeCreate equivalent ---

      // 1. Create the Vue app instance with the root component
      const app = createApp(OnBoarding);

      // 2. Use plugins (like Vuex store)
      app.use(store);

      // 3. Mount the app to the DOM element
      // The return value 'vm' is the root component instance
      const vm = app.mount('#on_boarding') as OnBoardingGlobal;

      // 4. Expose the component instance globally (optional, if needed by other scripts)
      window.onBoardingVue = vm;

      // 5. Define and expose the global launch function
      window.onBoardingVue.launchFor = async (
        goal: OnBoardingGoal,
        // MagicLink is included in the default set so the temporary placeholder
        // button shows up in modal flows during review. It can be removed
        // per-caller by passing an explicit authMethods list.
        authMethods: AuthMethods[] = [AuthMethods.Google, AuthMethods.Apple, AuthMethods.Email, AuthMethods.MagicLink]
      ) => {
        // Interact directly with the imported store
        store.commit('onBoarding/setAuthMethods', authMethods);
        await store.dispatch('onBoarding/setupFlowFor', goal);
      };

      window.onBoardingVue.setAddToListContext = (context: AddToListContext = {}) => {
        store.commit('onBoarding/setContextFromTrail', context);
      };

      console.log('Onboarding Vue 3 app initialized and mounted.');

    } catch (error) {
      console.error("Error initializing Vue 3 onboarding app:", error);
      // Handle initialization errors appropriately, maybe display a message
    }
  };

  // Run the initialization
  initializeAndMountOnboarding();

} else {
  console.warn("Onboarding DOM element '#on_boarding' not found.");
}
